<template>
  <div class="main_width m0a pt20 pb20">
    <ul class="title-ul">
      <li :class="type === 'good' && 'active'" @click="change('good')">最优报价</li>
      <li :class="type !== 'good' && 'active'" @click="change('')">机构报价</li>
    </ul>
    <discount-rate-web-base v-if="type !== 'good'" class="rate-main" :bankInfo="bankInfo"></discount-rate-web-base>
    <discount-good-rate-web-base v-else class="rate-main"></discount-good-rate-web-base>
  </div>
</template>

<script>
import DiscountGoodRateWebBase from './DiscountGoodRateWebBase.vue'
import DiscountRateWebBase from './DiscountRateWebBase.vue'
export default {
  name: "discountRateMenu",
  components: {
    DiscountRateWebBase,
    DiscountGoodRateWebBase
  },
  data () {
    return {
      type: 'good',
      bankInfo: {
        bankName: '',
        bankCode: ''
      }
    }
  },
  provide () {
    return {
      DiscountRate: this
    }
  },
  computed: {
    cuCom () {
      if (this.type === 'good') {
        return 'DiscountGoodRateWebBase'
      }
      return 'DiscountRateWebBase'
    }
  },
  methods: {
    change (type) {
      if (type === 'good') {
        this.bankInfo.bankCode = ''
        this.bankInfo.bankName = ''
      }
      this.type = type
    }
  }
}
</script>

<style lang="less" scoped>
.title-ul {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: stretch;
  background: #fff;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.11);
  position: relative;
  li {
    text-align: center;
    list-style: none;
    flex: 1;
    min-height: 60px;
    padding: 20px 0;
    font-size: 18px;
    color: #666;
    font-weight: bold;
    cursor: pointer;
    &:hover {
      color: #e1241a;
    }
    &.active {
      background: #e1241a;
      color: #fff;
      position: relative;
      &::after {
        content: '';
        position: absolute;
        border-left: 10px solid transparent;
        border-top: 10px solid #e1241a;
        border-right: 10px solid transparent;
        bottom: -10px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}
.rate-main {
  padding-top: 20px;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/discountRate/DiscountRate.vue